<template>
  <div class="hdBg">

    <div class="header-wrapper">
      <div class="logo" @click="routeTo('home')" style="cursor: pointer;">
        <img src="../assets/img/logo.png" alt="logo" />
      </div>
      <!-- 未登录时显示登录按钮，已登录时显示菜单按钮 -->
      <template v-if="userName == ''">
        <div class="mobile-login-btn" @click="wechatLogin">
          <span>登录</span>
        </div>
      </template>
      <template v-else>
        <div class="mobile-menu-btn" @click="toggleMenu">
          <Icon type="md-menu" size="24" />
        </div>
      </template>
      <!-- 桌面端菜单 -->
      <div class="desktop-menu">
        <Menu mode="horizontal" @on-select="routeTo">
          <MenuItem name="login" v-if="userName == ''"><span>登录</span></MenuItem>
          <template v-else>
            <MenuItem name="home"><span>首页</span></MenuItem>
            <Submenu name="myAccount">
              <template slot="title"><span>个人中心</span></template>
              <MenuItem name="myLeasson" id="menu-item-1">
                <span>我的课程</span>
              </MenuItem>
              <MenuItem name="account" id="menu-item-2">
                <span>个人基本信息</span>
              </MenuItem>
              <MenuItem name="resetPassword" id="menu-item-3">
                <span>密码重置</span>
              </MenuItem>
            </Submenu>
            <MenuItem name="notice">
            <Badge :count="noticeCount">
              <Icon type="md-notifications-outline" class="notice-icon" /><span>消息中心</span>
            </Badge>
            </MenuItem>
            <Submenu name="user">
              <template slot="title">
                <img src="../assets/img/hd.png" alt="avatar" />
                <span>{{ userName }},欢迎您</span>
              </template>
              <MenuItem name="loginOut"><span>退出登录</span></MenuItem>
            </Submenu>
          </template>
        </Menu>
      </div>
    </div>


    <!-- 移动端抽屉菜单 -->
    <Drawer placement="left" :closable="false" v-model="isMenuVisible" class="mobile-drawer">
      <div class="drawer-header" v-if="userName">
        <img src="../assets/img/hd.png" alt="avatar" class="drawer-avatar" />
        <span class="drawer-username">{{ userName }}</span>
      </div>
      <Menu theme="light" width="auto" @on-select="routeTo">
        <template>
          <MenuItem name="home">
          <Icon type="md-home" />
          首页
          </MenuItem>
          <MenuItem name="myLeasson">
          <Icon type="md-book" />
          我的课程
          </MenuItem>
          <MenuItem name="account">
          <Icon type="md-person" />
          个人基本信息
          </MenuItem>
          <MenuItem name="resetPassword">
          <Icon type="md-lock" />
          密码重置
          </MenuItem>
          <MenuItem name="unbindWeChat" v-if="hasWeChatBinding">
          <Icon type="md-close-circle" />
          解除绑定微信
          </MenuItem>
         
          <MenuItem name="notice">
          <Badge :count="noticeCount">
            <Icon type="md-notifications-outline" />
            消息中心
          </Badge>
          </MenuItem>
          <MenuItem name="loginOut">
          <Icon type="md-log-out" />
          退出登录
          </MenuItem>
        </template>
      </Menu>
    </Drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "home",
      isLogin: true,
      userName: "",
      noticeCount: 0,
      isMenuVisible: false,
      hasWeChatBinding: false // 是否有微信绑定
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },

    loginOut() {

      sessionStorage.removeItem("userNameSchool");
      sessionStorage.removeItem("token_retire_school");
      sessionStorage.removeItem("idCard");
      sessionStorage.removeItem("id");
      this.$store.commit("REMOVE_TOKEN", "token");
      this.$store.commit("DEL_STUDENTID", "studentId");
       
      // 在路由跳转后触发数据重新加载
      this.$router.push({ path: "/" }).then(() => {
      window.location.reload();
      });
    },
    routeTo(e) {
      this.isMenuVisible = false; // 点击菜单项后关闭菜单
      console.log('Menu item clicked:', e); // 添加调试日志
      if (e == "loginOut") {
        this.loginOut();
      } else if (e == "unbindWeChat") {
        this.unbindWeChat();
      }  else {
        const routeMap = {
          myLeasson: '/myLeasson',
          account: '/userInfo',
          bonus: '/bonus',
          resetPassword: '/resetPassword',
          notice: '/notice',
          home: '/'
        };
        const path = routeMap[e] || `/${e}`;
        console.log('Attempting to navigate to:', path); // 添加调试日志
        this.$router.push({ path }).catch(err => {
          console.error('Navigation failed:', err); // 添加错误处理
        });
      }
    },

    wechatLogin() {
      const appid = "wxe97386fcfdf3c866";
      const redirectUri = encodeURIComponent(`http://tjltb.tongji.edu.cn/retireSchool/login`);       
      const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
      window.location.href = wechatAuthUrl;
    },
     unbindWeChat() {
      var _this = this;
      var id = sessionStorage.getItem("id");
      var idCard = sessionStorage.getItem("idCard");
      if (id != null) {
        this.$Modal.confirm({
          title: '确认取消绑定',
          content: '确认取消绑定微信登录吗？',
          onOk: () => {
            this.$http
              .post("retire-manage/openId/deleteOpenId", {
                id: id,
                updatedBy:idCard
              })
              .then((res) => {
                  
                if (res.data.status === 2000) {
                  sessionStorage.removeItem("id");
                  window.location.reload();
                
                } else {
                  _this.$CustomMessageError(res.data.msg);
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          },
          onCancel: () => {
            // 用户取消操作，不执行任何操作
          }
        });
      }
    },
    bindWeChat() {
        const appid = "wxe97386fcfdf3c866";
        const redirectUri = encodeURIComponent(`http://tjltb.tongji.edu.cn/retireSchool/login/bind`);       
        const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
        window.location.href = wechatAuthUrl;
    },
    getUserInfo() {
      if (sessionStorage.getItem("userNameSchool")) {
        this.isLogin = false;
        this.userName = sessionStorage.getItem("userNameSchool");
        // 检查是否有微信绑定
       
        let id = sessionStorage.getItem("id");
      
        this.hasWeChatBinding = id !== null && id !== "null";
      }
    },
    getNoticeCount() {
      var _this = this;
      var studentId = _this.$store.state.studentId;
      if (studentId != null) {
        _this.$http
          .get("retire-school-manage/notice/getSchoolNoticeCnt", {
            params: {
              studentId: _this.$store.state.studentId,
            },
          })
          .then(function (res) {
            if (res.data.status === 2000) {
              _this.noticeCount = res.data.data;
              if (_this.noticeCount != 0) {
                _this.$http
                  .get("retire-school-manage/notice/getSchoolNotices", {
                    params: {
                      studentId: _this.$store.state.studentId,
                      startIndex: 1,
                      endIndex: 10,
                    },
                  })
                  .then(function (res) {
                    if (res.data.status === 2000) {
                      var processNotice = (noticeList) => {
                        _this.noticeCount = noticeList.length;
                        if (noticeList.length == 0) {
                          window.setTimeout(_this.getNoticeCount, 10000);
                          return;
                        }
                        let first = noticeList.shift();
                        _this.$Modal.info({
                          title: "通知",
                          content: first.content,
                          onOk: () => {
                            _this.$http
                              .post(
                                "retire-school-manage/notice/updateSchoolNotice",
                                {
                                  id: first.id,
                                  readInd: "0",
                                }
                              )
                              .then(function (res) {
                                window.setTimeout(
                                  () => processNotice(noticeList),
                                  1000
                                );
                              });
                          },
                        });
                      };
                      let list = res.data.data.schoolNoticeList.filter(
                        (res) => res.readInd == 1
                      );
                      processNotice(list);
                    }
                  });
                return;
              } else {
                window.setTimeout(_this.getNoticeCount, 10000);
              }
            }
          });
      }
    },
  },
  watch: {
    $route(to, from) {
      this.activeName = this.$route.params.currName;
      if (from.path == "/userInfoConfirm") {
        this.getUserInfo();
      }
    },
  },
  created() {
    this.getUserInfo();
    this.getNoticeCount();
  
  },
};
</script>

<style lang="less" scoped>
@import '../styles/base/_variables';


.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding-left: 3vw;
  padding-right: 3vw;
}

.logo {
  height: 40px;
  display: flex;
  align-items: center;

  @media (min-width: @screen-sm) {
    height: 50px;
  }

  img {
    height: 100%;
    width: auto;
  }
}

.desktop-menu {
  display: none !important;

  @media (min-width: @screen-sm) {
    display: block !important;
    flex: 1;
    margin-left: 40px;

    .ivu-menu-horizontal {
      height: 80px;
      line-height: 80px;
      display: flex;
      justify-content: flex-end;
      border: none;

      /deep/ #menu-item-1,
      /deep/ #menu-item-2,
      /deep/ #menu-item-3 {
        margin: 10px 0 !important;
        height: auto !important;
        line-height: 2 !important;
      }

      &::after {
        display: none !important;
      }
    }
    span {
      font-size: 18px;
      font-weight: 500;
    }
  }
}

.mobile-menu-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }

  @media (min-width: @screen-sm) {
    display: none;
  }
}

.mobile-login-btn {
  padding: 8px 16px;
  background-color: @primary-color;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  
  span {
    font-size: 16px;
  }

  &:active {
    opacity: 0.8;
  }

  @media (min-width: @screen-sm) {
    display: none;
  }
}

.mobile-drawer {
  .drawer-header {
    padding: 25px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  .drawer-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-right: 15px;
  }

  .drawer-username {
    font-size: 18px;
    color: @text-color;
    font-weight: 500;
  }

  .ivu-menu {
    border-right: none !important;
    &::after {
      display: none !important;
    }

    .ivu-menu-item {
      margin: 4px 0;
      padding: 16px 28px;
      display: flex;
      align-items: center;
      height: auto;
      line-height: 1.5;
      font-size: 20px;

      .ivu-icon {
        margin-right: 15px;
        font-size: 22px;
      }
    }
  }

  .ivu-badge {
    display: flex;
    align-items: center;

    .ivu-badge-count {
      position: static;
      margin-left: 8px;
    }
  }
}

.notice-icon {
  margin-right: 4px;
}
</style>